import { logout } from '@/helpers/auth';
import { checkIfAuthorized } from '@/helpers/router';

const authenticationRoutes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Authentication/Login'),
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        },
    },
    {
        path: '/forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/Authentication/ForgotPassword'),
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        },
    },
    {
        path: '/register/:token',
        name: 'Register',
        component: () => import('@/views/Authentication/Register'),
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        },
    },
    {
        path: '/reset-password/:token',
        name: 'ResetPassword',
        component: () => import('@/views/Authentication/ResetPassword'),
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        },
    },

    {
        path: '/register/confirm/:token',
        name: 'Register Confirm',
        component: () => import('@/views/Authentication/RegisterConfirm'),
        beforeEnter: (to, from, next) => {
            checkIfAuthorized(next);
        },
    },

    {
        path: '/logout',
        name: 'Logout',
        component: () => logout('/login'),
    },
];

export default authenticationRoutes;
